import React from 'react';
import { BlogPost } from '@/data/blogPosts';
import TableOfContents from './TableOfContents';
import {
  CalendarIcon,
  ClockIcon,
  TagIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';

interface BlogPostSidebarProps {
  post: BlogPost;
}

const BlogPostSidebar: React.FC<BlogPostSidebarProps> = ({ post }) => {
  return (
    <div className="w-full">
      <div className="mb-12 border-b border-zinc-200 pb-8 dark:border-zinc-800">
        <h3 className="mb-4 text-lg dark:text-white">Post Details</h3>

        <div className="space-y-4 text-sm">
          <div className="flex items-center text-zinc-600 dark:text-zinc-400">
            <CalendarIcon className="mr-2 h-5 w-5" />
            <span>{post.date}</span>
          </div>

          <div className="flex items-center text-zinc-600 dark:text-zinc-400">
            <ClockIcon className="mr-2 h-5 w-5" />
            <span>{post.readTime}</span>
          </div>

          <div className="flex items-center text-zinc-600 dark:text-zinc-400">
            <TagIcon className="mr-2 h-5 w-5" />
            <span>{post.category}</span>
          </div>
        </div>

        <div className="mt-6">
          <h4 className="mb-2 text-sm uppercase tracking-wider text-zinc-500 dark:text-zinc-400">
            Share
          </h4>
          <div className="flex space-x-2">
            <button className="rounded-full bg-zinc-100 p-2 transition-colors hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-700">
              <ShareIcon className="h-5 w-5 text-zinc-600 dark:text-zinc-400" />
            </button>
          </div>
        </div>
      </div>

      {post.content && (
        <div className="hidden lg:block">
          <div className="lg:sticky lg:top-28">
            <TableOfContents content={post.content} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogPostSidebar;
